import axios from "axios";

const baseURL = process.env.REACT_APP_MEMGO_APP_BASEURL;
const authToken = process.env.REACT_APP_MEMGO_AUTH_TOKEN;

export const getAgentsList = () => {
  return axios({
    method: "GET",
    url: `${baseURL}/ai-voice-agent/agent-list`,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
};

export const getAIAgentsData = (params: any) => {
  return axios({
    method: "GET",
    url: `${baseURL}/ai-voice-agent/agent/fetch-all`,
    params,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
};

export const getAgentCalls = (agentId: string, params: any) => {
  return axios({
    method: "GET",
    url: `${baseURL}/ai-voice-agent/agent/${agentId}/calls/fetch-all`,
    params,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
};

export const getCallDetails = (agentId: string, callId: string) => {
  return axios({
    method: "GET",
    url: `${baseURL}/ai-voice-agent/agent/${agentId}/call/${callId}/get-details`,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
};


export const getToolsForCall = (agentId: string, callId: string) => {
  return axios({
    method: "GET",
    url: `${baseURL}/ai-voice-agent/agent/${agentId}/call/${callId}/tools/fetch-all`,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
}